import './_product-info.scss';
import component from './product-info';

export default component;
